export default __webpack_public_path__ + "static/media/ImageLetter.13dd8077.png";